import { render, staticRenderFns } from "./user.vue?vue&type=template&id=3025a9f4&lang=pug"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoverlyV2HeaderPage: require('/app/components.v2/header/Page.vue').default,LoverlyV2HeaderDashboard: require('/app/components.v2/header/Dashboard.vue').default,LoverlyConfirmationPopup: require('/app/components/modals/ConfirmationPopup.vue').default,LoverlyV2ModalAuth: require('/app/components.v2/modal/Auth.vue').default,LoverlyV2Footer: require('/app/components.v2/elements/Footer.vue').default})
